import { isDesktop } from 'react-device-detect';
import styles from './WriteReviewModal.module.scss';
import imsiProduct from '../../assets/imsi/imsiProduct4.png';
import { useEffect, useState } from 'react';
import bottomArrow2 from '../../assets/bottomArrow.png';
import star from '../../assets/star.png';
import emptyStar from '../../assets/emptyStar.png';
import camera from '../../assets/camera.png';
import closeBtn from '../../assets/closeBtn04.png';
import inputLogo from '../../assets/inputLogo.png';
import bottomArrow from '../../assets/bottomArrow05.png';
import { useNavigate, useParams } from 'react-router-dom';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
import { IReviewDataType, IReviewYetType } from '../../pages/MyReview/MyReview';
import { useTranslation } from 'react-i18next';
import check from '../../assets/checkMark.png';
interface IPropsType {
  closer: React.Dispatch<React.SetStateAction<boolean>>;
}
interface IBeforeEditImages {
  created_at: string;
  id: number;
  imagable_id: number;
  imagable_type: string;
  image: string;
  updated_at: string | null;
}
function WriteReviewModal(props: IPropsType) {
  const { t, i18n } = useTranslation();

  const { data: writableOrders } = useQuery<IReviewYetType[]>(
    ['reviewWritableOrder'],
    () =>
      axiosClient
        .get('/data/product_talk/list/review_yet')
        .then((res) => res.data.data),
    { refetchOnWindowFocus: false },
  );

  const [selectedOrder, setSelectedOrder] = useState<IReviewYetType>();
  const [orderListOpen, setOrderListOpen] = useState(false);
  const [gender, setGender] = useState(-1);
  const [age, setAge] = useState(-1);
  const [weight, setWeight] = useState(0);
  const [content, setContent] = useState('');
  const navigate = useNavigate();
  const [customReviewStar1, setCustomReviewStar1] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [customReviewStar2, setCustomReviewStar2] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [customReviewStar3, setCustomReviewStar3] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [customReviewStar4, setCustomReviewStar4] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [imageSrc, setImageSrc] = useState<string[]>([]);
  const [imageBinary, setImageBinary] = useState<any[]>([]);
  const [beforeEditImage, setBeforeEditImage] = useState<IBeforeEditImages[]>(
    [],
  );
  const [guideOpen, setGuideOpen] = useState(false);
  const [marketingAgree, setMarketingAgree] = useState(false);
  const [isWriting, setIsWriting] = useState(false);
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  function encodeFileToBase64(file: any): any {
    return new Promise(function (resolve, reject) {
      let fr = new FileReader();
      fr.onload = function () {
        resolve(fr.result);
      };
      fr.onerror = function () {
        reject(fr);
      };
      fr.readAsDataURL(file);
    });
  }
  function deleteUploadImage(idx: number) {
    for (let i = 0; i <= idx; i++) {
      if (imageSrc[i] == 'deleted') idx += 1;
      else break;
    }
    let list = [...imageSrc];
    let binaryList = [...imageBinary];
    if (typeof imageBinary[idx] == 'string') {
      list[idx] = 'deleted';
      binaryList[idx] = 'deleted';
    } else {
      list.splice(idx, 1);
      binaryList.splice(idx, 1);
    }
    setImageSrc(list);
    setImageBinary(binaryList);
  }
  function handleValidate() {
    if (!selectedOrder) {
      alert(t('other.49'));
      return false;
    }
    if (gender == -1) {
      alert(t('other.5'));
      return false;
    }
    if (age == -1) {
      alert(t('other.6'));
      return false;
    }
    if (
      !customReviewStar1.includes(true) ||
      !customReviewStar2.includes(true) ||
      !customReviewStar3.includes(true) ||
      !customReviewStar4.includes(true)
    ) {
      alert(t('other.7'));
      return false;
    }
    if (content.length < 20) {
      alert(t('other.8'));
      return false;
    }
    if (!marketingAgree) {
      alert(t('other.60'));
      document
        .querySelector('.reviewModal')!
        .scrollTo(0, document.querySelector('.reviewModal')!.clientHeight);
      return false;
    }
    return true;
  }
  async function handleSubmit() {
    if (!handleValidate()) return;
    let imageList = [...imageBinary];
    if (isWriting) {
      alert(t('other.9'));
      return;
    }
    let formData = new FormData();
    formData.append('talk_type', '상품평가');
    formData.append('content', content);
    formData.append('product_id', String(selectedOrder?.product_id));
    formData.append('gender', gender == 0 ? 'M' : 'F');
    formData.append(
      'age',
      String(
        age == 0 ? 20 : age == 1 ? 30 : age == 2 ? 40 : age == 3 ? 50 : '',
      ),
    );
    formData.append('weight', String(weight));
    formData.append(
      'stars0',
      String(customReviewStar1.filter((isTrue) => isTrue).length * 20),
    );
    formData.append(
      'stars1',
      String(customReviewStar2.filter((isTrue) => isTrue).length * 20),
    );
    formData.append(
      'stars2',
      String(customReviewStar3.filter((isTrue) => isTrue).length * 20),
    );
    formData.append(
      'stars3',
      String(customReviewStar4.filter((isTrue) => isTrue).length * 20),
    );
    formData.append('is_secret', 'N');
    for (let i = 0; i < imageList.length; i++) {
      if (typeof imageList[i] == 'object')
        formData.append(`file${i}`, imageList[i]);
    }
    formData.append(
      'order_product_id',
      String(selectedOrder?.order_product_id!),
    );
    formData.append('marketing_agree', marketingAgree ? 'Y' : 'N');
    axiosClient
      .post('/func/product_talk', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((res) => {
        alert(t('other.10'));
        props.closer(false);
      })
      .catch((err) => setIsWriting(false));

    setIsWriting(true);
  }
  return (
    <div
      className={`${styles.container} ${
        isDesktop ? styles.pc : styles.mobile
      } writeReviewModal`}
    >
      <div className={`${styles.contentWrap} reviewModal`}>
        <div className={styles.head}>
          <div className={styles.left}>
            {/* <span>포토후기 500P</span>
            <span>일반후기 100P</span> */}
          </div>
          <div className={styles.closeBtn} onClick={() => props.closer(false)}>
            {t('productDetail.38')}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>{t('productDetail.14')}</div>
          {
            <div className={styles.orderListWrap}>
              <div onClick={() => setOrderListOpen((prev) => !prev)}>
                <span>{t('productDetail.49')}</span>
                <img
                  src={bottomArrow2}
                  alt="bottomArrow"
                  style={{ transform: orderListOpen ? 'rotate(180deg)' : '' }}
                />
              </div>
              {orderListOpen && (
                <ul>
                  {writableOrders?.map((order) => (
                    <li
                      key={order.order_product_id}
                      onClick={() => {
                        setSelectedOrder(order);
                        setOrderListOpen(false);
                      }}
                    >
                      <div className={styles.productThumbnail}>
                        <img src={order.list_image} alt="productThumbnail" />
                      </div>
                      <div className={styles.productInfoWrap}>
                        <h4 className={styles.productName}>
                          {order.product_name}
                        </h4>
                        <div className={styles.optionBox}>
                          <span>{t('productDetail.48')}</span>
                          <span>
                            {order.op_option1
                              ? order.op_option1
                              : order.product_name}
                            {order.op_option2 && ' / ' + order.op_option2}
                            {order.op_option3 && ' / ' + order.op_option3}
                          </span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          }
          {/* 제품 상세페이지에서 리뷰 새로 작성시 노출 */}
          {selectedOrder && (
            <div className={styles.productInfoWrap}>
              <div className={styles.productThumbnail}>
                <img src={selectedOrder.list_image} alt="imsiProduct" />
              </div>
              <div className={styles.productInfo}>
                <span className={styles.productName}>
                  [ {selectedOrder.product_name} ]
                </span>
                <div className={styles.optionInfo}>
                  <span>{t('productDetail.48')}</span>
                  <span>
                    {selectedOrder.op_option1
                      ? selectedOrder.op_option1
                      : selectedOrder.product_name}
                    {selectedOrder.op_option2 &&
                      ' / ' + selectedOrder.op_option2}
                    {selectedOrder.op_option3 &&
                      ' / ' + selectedOrder.op_option3}
                  </span>
                </div>
              </div>
            </div>
          )}
          <div className={styles.userInfoWrap}>
            <div className={styles.gender}>
              <span>{t('reviewModal.1')}</span>
              <ul>
                <li
                  className={gender == 0 ? styles.hit : ''}
                  onClick={() => setGender(0)}
                >
                  {t('productDetail.36')}
                </li>
                <li
                  className={gender == 1 ? styles.hit : ''}
                  onClick={() => setGender(1)}
                >
                  {t('productDetail.37')}
                </li>
              </ul>
            </div>
            <div className={styles.age}>
              <span>{t('reviewModal.2')}</span>
              <ul>
                <li
                  className={age == 0 ? styles.hit : ''}
                  onClick={() => setAge(0)}
                >
                  {t('productDetail.32')}
                </li>
                <li
                  className={age == 1 ? styles.hit : ''}
                  onClick={() => setAge(1)}
                >
                  {t('productDetail.33')}
                </li>
                <li
                  className={age == 2 ? styles.hit : ''}
                  onClick={() => setAge(2)}
                >
                  {t('productDetail.34')}
                </li>
                <li
                  className={age == 3 ? styles.hit : ''}
                  onClick={() => setAge(3)}
                >
                  {t('productDetail.35')}
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.scoreWrap}>
            <span>{t('reviewModal.3')}</span>
            <ul className={styles.customReviewList}>
              <li>
                <span>{t('productDetail.6')}</span>
                <div className={styles.starWrap}>
                  {customReviewStar1.map((isTrue, idx) => (
                    <div
                      onClick={() => {
                        let newScore: boolean[] = [];
                        for (let i = 0; i < 5; i++) {
                          if (i <= idx) newScore.push(true);
                          else newScore.push(false);
                          setCustomReviewStar1(newScore);
                        }
                      }}
                    >
                      {isTrue ? (
                        <img src={star} alt="star" />
                      ) : (
                        <img src={emptyStar} alt="emptyStar" />
                      )}
                    </div>
                  ))}
                </div>
              </li>
              <li>
                <span>{t('productDetail.7')}</span>
                <div className={styles.starWrap}>
                  {customReviewStar2.map((isTrue, idx) => (
                    <div
                      onClick={() => {
                        let newScore: boolean[] = [];
                        for (let i = 0; i < 5; i++) {
                          if (i <= idx) newScore.push(true);
                          else newScore.push(false);
                          setCustomReviewStar2(newScore);
                        }
                      }}
                    >
                      {isTrue ? (
                        <img src={star} alt="star" />
                      ) : (
                        <img src={emptyStar} alt="emptyStar" />
                      )}
                    </div>
                  ))}
                </div>
              </li>
              <li>
                <span>{t('productDetail.8')}</span>
                <div className={styles.starWrap}>
                  {customReviewStar3.map((isTrue, idx) => (
                    <div
                      onClick={() => {
                        let newScore: boolean[] = [];
                        for (let i = 0; i < 5; i++) {
                          if (i <= idx) newScore.push(true);
                          else newScore.push(false);
                          setCustomReviewStar3(newScore);
                        }
                      }}
                    >
                      {isTrue ? (
                        <img src={star} alt="star" />
                      ) : (
                        <img src={emptyStar} alt="emptyStar" />
                      )}
                    </div>
                  ))}
                </div>
              </li>
              <li>
                <span>{t('productDetail.9')}</span>
                <div className={styles.starWrap}>
                  {customReviewStar4.map((isTrue, idx) => (
                    <div
                      onClick={() => {
                        let newScore: boolean[] = [];
                        for (let i = 0; i < 5; i++) {
                          if (i <= idx) newScore.push(true);
                          else newScore.push(false);
                          setCustomReviewStar4(newScore);
                        }
                      }}
                    >
                      {isTrue ? (
                        <img src={star} alt="star" />
                      ) : (
                        <img src={emptyStar} alt="emptyStar" />
                      )}
                    </div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
          <div className={styles.weightInfoWrap}>
            <span>{t('reviewModal.4')}</span>
            <div className={styles.weight}>
              <span>-</span>
              <input
                type="text"
                value={weight}
                onChange={(e) => {
                  if (isNaN(Number(e.currentTarget.value))) return;
                  if (Number(e.currentTarget.value) < 0) setWeight(0);
                  else setWeight(Number(e.currentTarget.value));
                }}
              />
              <span>kg</span>
            </div>
          </div>
          <div className={styles.uploadImagesWrap}>
            <span>{t('reviewModal.5')}</span>
            <ul className={styles.uploadImageList}>
              {imageSrc
                .filter((src) => src !== 'deleted')
                .map((image, idx) => (
                  <li className={styles.selectedImageWrap} key={image}>
                    <img src={image} alt="selectedImg" />
                    <div
                      className={styles.closeBtn}
                      onClick={() => deleteUploadImage(idx)}
                    >
                      <img src={closeBtn} alt="closeBtn" />
                    </div>
                  </li>
                ))}
              {(() => {
                let list: string[] = [];
                for (
                  let i = 0;
                  i < 3 - imageSrc.filter((src) => src !== 'deleted').length;
                  i++
                )
                  list.push('');
                return list.map(() => (
                  <li className={styles.selectedImageWrap}></li>
                ));
              })()}
            </ul>
            <div className={styles.inputImgBtn}>
              <input
                type="file"
                accept=".png, .jpg, .jpeg"
                multiple
                onChange={(e) => {
                  let files = e.currentTarget.files;
                  let readers = [];
                  if (!files!.length) return;
                  let binaryList = [];
                  for (let i = 0; i < 3 - imageBinary.length; i++) {
                    if (!files![i]) break;
                    binaryList.push(files![i]);
                  }
                  setImageBinary([...imageBinary, ...binaryList]);
                  for (let i = 0; i < files!.length; i++) {
                    readers.push(encodeFileToBase64(files![i]));
                  }
                  Promise.all(readers).then((values) => {
                    let list = [];
                    if (values.length + imageSrc.length > 3) {
                      alert(t('other.11'));
                    }
                    for (let i = 0; i < 3 - imageSrc.length; i++) {
                      if (!values[i]) break;
                      list.push(values[i]);
                    }
                    setImageSrc([...imageSrc, ...list]);
                  });
                }}
              />
              <div className={styles.imgBtn}>
                <img src={camera} alt="cameraIcon" />
                <span>{t('reviewModal.5')}</span>
              </div>
            </div>
          </div>
          <div className={styles.reviewFormWrap}>
            <div className={styles.title}>
              <img src={inputLogo} alt="inputLogo" />
              <span>{t('reviewModal.8')}</span>
            </div>
            <textarea
              placeholder={`${t('reviewModal.6')}`}
              value={content}
              onChange={(e) => setContent(e.currentTarget.value)}
            />
          </div>
          <button className={styles.submitBtn} onClick={handleSubmit}>
            {t('reviewModal.7')}
          </button>
          <div className={styles.reviewGuideWrap}>
            <div
              className={styles.guideTitle}
              onClick={() => setGuideOpen((prev) => !prev)}
            >
              <span>{t('reviewModal.9')}</span>
              <img
                src={bottomArrow}
                alt="bottomArrow"
                style={{
                  transform: guideOpen ? 'rotate(180deg)' : 'rotate(0)',
                }}
              />
            </div>
            {guideOpen && (
              <div className={styles.guideContent}>
                {t('reviewModal.10')}
                <br />
                <br />
                {t('reviewModal.11')}
                <br />
                1.{t('reviewModal.12')}
                <br /> 2. {t('reviewModal.13')} <br />
                3. {t('reviewModal.14')} <br />
                4. {t('reviewModal.15')} <br />
                5. {t('reviewModal.16')}
                <br />
                6. {t('reviewModal.17')} <br />
                7. {t('reviewModal.18')}
              </div>
            )}
          </div>
          <div
            className={styles.marketingAgreement}
            onClick={() => setMarketingAgree((prev) => !prev)}
          >
            <div
              className={`${styles.marketingCheckbox} ${
                marketingAgree ? styles.isChecked : ''
              }`}
            >
              {marketingAgree && <img src={check} />}
            </div>
            <p>{t('reviewModal.19')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WriteReviewModal;
